import { api } from '@cwd/lib/main';
import { SmtpServer, SmtpServerAccounts } from './SmtpServers.types';


export async function getSmtpServers(): Promise<SmtpServer[]> {
    return api.get('/BackOffice/SmtpServers');
}

export async function getSmtpServerAccounts(smtpServerId: string): Promise<SmtpServerAccounts> {
    return api.get(`/BackOffice/SmtpServers/${smtpServerId}/Accounts`);
}
